import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import { Col, Icon, Input, Row, Select } from 'antd';
import React from 'react';

import ProcessContext from '../ProcessContext';

const Option = Select.Option;

interface IToDoComponentPropsType {
  options?: string;
  onChange: Function;
  isAPI?: boolean;
  repeat?: boolean;
}

interface IToDoTaskComponentStateType {
  options: any;
  repeat?: boolean;
};
export default class ToDoComponentProcess extends React.Component<IToDoComponentPropsType, IToDoTaskComponentStateType> {
  constructor(props: IToDoComponentPropsType) {
    super(props);
    this.state = {
      options: this.props.options || [{ id: Math.random().toString(36).substr(2, 9), sectionId: undefined, label: undefined }],
    };
  }

  componentDidUpdate = (nextProps: any) => {
    if (this.props.repeat !== nextProps.repeat) {
      if (this.props.repeat) {
        this.setState(state => ({
          options: [state.options[0]],
        }),() => this.onSubmiSelectComponent());
      }
    }
  }


  handleInputItemChange = (idx: any) => async (evt: any) => {
    const newValueLabel = this.state.options.map((valueLabel: any, sidx: any) => {
      if (idx !== sidx) return valueLabel;
      return { ...valueLabel, label: evt.target.value };
    });
    this.setState({ options: newValueLabel },() => this.onSubmiSelectComponent());
  }
  handleSelectPageChange = (idx: any) => (evt: any) => {
    const selectToDo = this.state.options.map((selectPage: any, sidx: any) => {
      if (idx !== sidx) return selectPage;
      return { ...selectPage, sectionId: evt };
    });
    this.setState({ options: selectToDo },()=> this.onSubmiSelectComponent());
  }
  handleAddNewSelectList = async () => {
    if (!this.props.repeat) {
      this.setState(state => ({
        options: state.options.concat([{ id: Math.random().toString(36).substr(2, 9), sectionId: undefined, label: undefined }]),
      }),()=> this.onSubmiSelectComponent());
    }

  }
  handleRemoveSelectGoTo = (index: number) => async () => {
    this.setState(state => ({
      options: state.options.filter((section: any, sindex: number) => index !== sindex),
    }),() => this.onSubmiSelectComponent());
    
  }

  getPages(pages: any, currentPage: any) {
    const selectItems: string[] = [];
    const options: JSX.Element[] = []

    for (let items of pages) {
      if (items.id) {
        selectItems.push(items);
      }
      const indexSelectSection = selectItems.findIndex((idTitle: any) => idTitle.id === currentPage.id)
      if (indexSelectSection > -1) {
        selectItems.splice(indexSelectSection)
      }
    }
    selectItems.map((page: any, index: number) => (
      options.push(
        <Option key={index} value={page.id}>
          {page.title}
        </Option>
      )
    ))
    return options;
  }


  onSubmiSelectComponent() {
    this.props.onChange(this.state.options)
  }
  render() {    
    return (
      <div>
        {this.state.options && this.state.options.map((item: any, idx: number) => (
          <div key={idx}>
            <Row>
              <Col span={10} >
                <ProcessContext.Consumer>
                  {({ pages, currentPage }) => (
                    <>
                      <Select
                        value={item.sectionId}
                        onChange={this.handleSelectPageChange(idx)}
                        placeholder={I18n.l("formflow.components.goToComponent.selectGoToPlaceHolder")}
                        style={{ width: '90%' }}
                      >
                        {this.getPages(pages, currentPage)}
                      </Select>
                      <div>
                        {item.sectionId === undefined &&
                          <div style={{ color: 'red', marginBottom: '10px', fontWeight: 'bold' }}>
                            <span >{I18n.l('label.selectPage')}</span>
                          </div>
                        }
                      </div>
                    </>
                  )}
                </ProcessContext.Consumer>
              </Col>
              <Col span={10} >
                <Input
                  placeholder={I18n.l('label.components.writeHere')}
                  style={{ backgroundColor: 'white', width: '90%', border: '1px solid #C8C8C8' }}
                  value={item.label}
                  maxLength={150}
                  onChange={this.handleInputItemChange(idx)}
                />
                {this.state.options.length > 1 &&
                  <span onPointerDown={this.handleRemoveSelectGoTo(idx)}>
                    <Icon
                      style={{ color: 'red', marginLeft: '5px', cursor: "pointer" }}
                      type="close"
                    />
                  </span>
                }
                <div>
                  {item.label === '' &&
                    <div style={{ color: 'red', marginBottom: '10px', fontWeight: 'bold' }}>
                      <span >{I18n.l('formflow.labels.requiredField')}</span>
                    </div>
                  }
                </div>
              </Col>
            </Row>
          </div>
        ))}
        {!this.props.repeat &&
          <Row style={{ cursor: 'pointer', marginTop: '2rem' }} onPointerDown={this.handleAddNewSelectList} >
            <Col span={2} >
              <FontAwesomeIcon color=' #1890ff' size='2x' icon={'plus-circle'} />
            </Col>
            <Col >
              <div style={{ color: '#354D62' }}>{I18n.l("common.addNew")}</div>
            </Col>
          </Row>
        }
      </div>
    );
  }
}